// Inline panel that lists potential duplicate pairs and lets the user delete
// one item from each pair. Layout (header + confidence-badged rows of two
// cards) is shared between Transactions and Recurring; the cards themselves
// differ (transactions have a date, recurring have a frequency), so the
// caller passes a render-prop for the card body.

export default function DuplicatesPanel({ pairs, onDelete, renderCard, emptyLabel }) {
  return (
    <div style={{ background: '#0f1117', border: '1px solid #1e2235', borderRadius: 12, padding: 14, marginBottom: 16 }}>
      <div style={{ fontSize: 11, color: '#94a3b8', fontFamily: "'Courier New', monospace", letterSpacing: 1, marginBottom: 12 }}>
        DUPLICATE SCAN — {pairs.length} PAIR{pairs.length !== 1 ? 'S' : ''}
      </div>

      {pairs.length === 0 ? (
        <div style={{ fontSize: 13, color: '#94a3b8', padding: '6px 0' }}>
          {emptyLabel || 'Nothing suspicious — your books look clean.'}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {pairs.map(pair => (
            <div key={`${pair.a.id}|${pair.b.id}`}
              style={{ border: '1px solid #1e2235', borderRadius: 10, padding: 10 }}>
              <div style={{ marginBottom: 8 }}>
                <ConfidenceBadge level={pair.confidence} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                {renderCard(pair.a, () => onDelete(pair.a))}
                {renderCard(pair.b, () => onDelete(pair.b))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ConfidenceBadge({ level }) {
  const isHigh = level === 'high';
  return (
    <span style={{
      background: isHigh ? '#7f1d1d' : '#78350f',
      color: isHigh ? '#fca5a5' : '#fcd34d',
      fontSize: 10,
      padding: '3px 8px',
      borderRadius: 4,
      fontFamily: "'Courier New', monospace",
      letterSpacing: 0.5,
      fontWeight: 600,
    }}>
      {isHigh ? 'HIGH CONFIDENCE — LIKELY DUPLICATE' : 'POSSIBLE DUPLICATE — CATEGORIES DIFFER'}
    </span>
  );
}
